module.exports = "/virtual-football-league/img/amblems/left/logos/Marseille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Marseille.png
// module id = 2112
// module chunks = 4